import { Component } from "react";
import Headerdash from "../components/headerdash";
import { Link } from "react-router-dom";

class Dashy extends Component {

    constructor() {
        super();
        this.state = {'homepage': []}
    }

    componentDidMount() {
        fetch('https://api.voicecoach.net/home')
        .then(res => res.json())
        .then(jr => {
            this.setState({homepage: jr._3Headings})
        });
    }

    handleChange = (evt, i, elem) => {
        const newHomepage = [...this.state.homepage];
        newHomepage[i][elem] = evt.target.value;
        this.setState({homepage: newHomepage});
    }

    updateHome = () => {
        let homecontents = {};
        homecontents['_3Headings'] = this.state.homepage;
        fetch('https://api.voicecoach.net/updatehome', {keepalive: true, credentials: 'include', method:'post', body: JSON.stringify(homecontents),
        headers: {'Content-Type':'application/json'}})
        .then(res => res.text())
        .then(ok => { if (ok === 'OK') {window.location.href = "/"}});
    }
     
    render() {
        let r = this.state.homepage;
        r = r.map((x, i) => {
            let section = `/edit/section/${this.state.homepage[i].uuid}`;
            return <div key={x.id} className="col-12 col-lg-4">
            <div className="px-5 my-5">
                <img src={x.image} className="w-50" alt="for something" />
            </div>
            <div className="heading3 text-center">
                <div className="form-group">
            <input type="text" className="form-control form-control-lg display-3"
            value={this.state.homepage[i].heading}
            onChange={(evt) => this.handleChange(evt, i, 'heading')}
            />
            </div><div className="form-group mt-1">
            <textarea className="form-control"
            onChange={(evt) => this.handleChange(evt, i, 'content')}
            defaultValue={this.state.homepage[i].content}
            ></textarea>
            </div>
            </div>
            <div className="mt-4"><Link to={section}>Edit Details Page</Link></div>
            </div>});
        return <>
        <Headerdash />
        <div className="container">
        <div className="row">
            {r}
            <div className="col-lg-6 col-12 mt-5">
                <button onClick={this.updateHome} className="btn btn-primary">Update Homepage Section Contents</button>
            </div>
        </div>
        </div>
        </>
    }
}

export default Dashy;